import { default as en } from "./en/messages";
import { default as ar } from "./ar/messages";

export default { en: { translation: en }, ar: { translation: ar } };
